import * as Joi from "joi-browser";

const schema = Joi.object().keys({
  message: Joi.string().required()
});
export default formData =>
  Joi.validate(formData, schema, { abortEarly: false }, err => {
    if (!err) return null;
    let validationData = {
      message: null
    };

    err.details.map(error => (validationData[error.path[0]] = error.message));

    return validationData;
  });
